// extracted by mini-css-extract-plugin
export default {"container":"Name_container__SetCf","content":"Name_content__nPSya","textContainer":"Name_textContainer__z0J0Q"};